module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAABHNCSVQICAgIfAhkiAAAAThJREFUWEftls1NwzAYhp+PVpy7AQcGIBuQAxmADegEcGOG3toNGAMpSA0DIDFCNqC9gz6U36aV3di+BCT77OR98th+HWHiIRPnEwGigf9rQDNKhCuUpeS8hJ6mIAN6R8oF2zpUeZecNAJEA9FANPAnDWjKQgp25+CsTagZa4RHU9WONaFmJNA35b28UdggjAAVOZd89Q+d9P05gD5cWLRVvZGcJy+AuuIzCoRbE4QNwBC+Z0Yir5T+AI2FSt3NKYQJwBgOqeR8Bu2B2oIFAqUc3oZQK95y0L7HIbzKGL2OjRA/rJjx3K7xB3AdEu4EYDShA3TlG2Hewjh/ebcsowa6iUcmjgEaj4p3uLMBI0TzN9SNoHBvAMtyBIcHAQwg1kCC8jB21IKPYegF4/Oc8yb0eanP3MkBfgENZrEh8PrJmAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/chart_down_arrow.png
// module id = P/i9
// module chunks = 3